import React from "react";
import { cn } from "../../../lib/utils";
import { FOCUS_RING } from "./classes";

/**
 * A Performance metric: label, big display-face number (Overview's card), caption (wireframe:
 * "Courses sold / 3 / ₹15,000"). With `onClick` the whole card is a button that opens
 * the filtered list; without, it is plain ("Total revenue · no click").
 */
export default function MetricCard({ label, value, caption, tone = "card", onClick, testId }) {
  const body = (
    <>
      <span className="block text-xs uppercase tracking-[0.18em] text-eh-muted">{label}</span>
      <span className="mt-3 block break-words font-display text-4xl leading-none text-eh-ink">{value}</span>
      <span className="mt-1 block text-sm text-eh-muted">{caption}</span>
    </>
  );
  const cls = cn("block w-full rounded-2xl border border-eh-border-soft p-6 text-left", tone === "positive" ? "bg-eh-sage/20" : "bg-eh-cream");
  return onClick
    ? <button type="button" onClick={onClick} data-testid={testId} className={cn(cls, "hover:bg-eh-cream-deep transition-colors", FOCUS_RING)}>{body}</button>
    : <div data-testid={testId} className={cls}>{body}</div>;
}
